import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userLogin: (state, action) => {
      state.user = action.payload;
    },
    userLogout: (state) => {
      state.user = null;
    },
    userMutate: (state, action) => {
      state.user = Object.assign(state.user, action.payload);
    },
  },
});

export const userState = (state) => state.user;

export const { userLogin, userLogout, userMutate } = userSlice.actions;

export default userSlice.reducer;
